<template>
  <div id="approve-block" class="content-block">
    <div class="filter-layer">
      <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="72px" label-position="left">
        <el-form-item label="审批类型" prop="flowMainType">
          <el-select v-model="queryParams.flowMainType" placeholder="请选择审批类型" size="small">
            <el-option v-for="dict in flowMainTypeOptions" :key="dict.dictValue" :label="dict.dictLabel"
              :value="dict.dictValue" />
          </el-select>
        </el-form-item>

        <el-form-item label="流程状态" prop="nodeProcessStatus" v-if="listType == 'myapproval'">
          <el-select v-model="queryParams.nodeProcessStatus" placeholder="请选择流程状态" size="small">
            <el-option v-for="dict in myapprovalProcessStatusOptions" :key="dict.dictValue" :label="dict.dictLabel"
              :value="dict.dictValue" />
          </el-select>
        </el-form-item>

        <el-form-item label="流程状态" prop="processStatus" v-if="listType == 'mylauch'">
          <el-select v-model="queryParams.processStatus" placeholder="请选择流程状态" size="small">
            <el-option v-for="dict in mylauchProcessStatusOptions" :key="dict.dictValue" :label="dict.dictLabel"
              :value="dict.dictValue" />
          </el-select>
        </el-form-item>

        <el-form-item label="流程名称" prop="processName">
          <el-input v-model="queryParams.processName" placeholder="请输入流程名称" clearable size="small"
            @keyup.enter.native="handleQuery" />
        </el-form-item>

        <el-form-item label="发起人" prop="launchUserName" v-if="listType == 'myapproval'">
          <el-input v-model="queryParams.launchUserName" placeholder="请输入发起人" clearable size="small"
            @keyup.enter.native="handleQuery" />
        </el-form-item>
        <el-form-item style="margin-right: 16px;">
          <el-button size="small" class="grey-btn" @click="handleResetForm" :disabled="calcQueryParamsDisable()"><svg-icon
              iconClass="icon-refresh" style="width: 16px;height: 16px;" />重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="handleQuery"><svg-icon iconClass="icon-search"
              style="width: 16px;height: 16px;" />查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-layer">
      <el-table ref="listTableRef" :data="tableList"
        :header-cell-style="{ background: '#F2F3F5', color: '#1D2129', fontWeight: 500, padding: '12px 10px' }"
        :cell-style="{
            color: '#313843',
            fontWeight: 400,
            padding: '12px 10px'
          }" height="100%">
        <el-empty description="暂无数据" slot="empty" :image="require('@/assets/images/home/default.png')" :image-size="220">
        </el-empty>
        <el-table-column label="流程名称" prop="processName" min-width="106" show-overflow-tooltip />
        <el-table-column label="流程状态" prop="nodeProcessStatus" min-width="106" :formatter="myapprovalProcessStatusFormat"
          v-if="listType == 'myapproval'">
          <template slot-scope="scope">
            <div class="flex-center" v-if="myapprovalProcessStatusFormat(scope.row)">
              <span class="dot" :style="{ background: myapprovalProcessStatusFormat(scope.row).bg }"></span>
              <span>{{ myapprovalProcessStatusFormat(scope.row).statusText }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="106" label="流程状态" prop="processStatus" :formatter="mylauchProcessStatusFormat"
          v-if="listType == 'mylauch'">
          <template slot-scope="scope">
            <div class="flex-center" v-if="mylauchProcessStatusFormat(scope.row)">
              <span class="dot" :style="{ background: mylauchProcessStatusFormat(scope.row).bg }"></span>
              <span>{{ mylauchProcessStatusFormat(scope.row).statusText }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="106" label="发起人" prop="launchUserName" show-overflow-tooltip />
        <el-table-column min-width="106" label="当前审批人" prop="currNodeUserName" show-overflow-tooltip />
        <el-table-column min-width="106" label="审批类型" prop="flowType" :formatter="flowMainTypeFormat" />
        <!-- <el-table-column label="流程描述" prop="processDesc" width="100" show-overflow-tooltip /> -->
        <!-- <el-table-column label="流程节点总数" prop="nodeNum" width="120" /> -->
        <el-table-column min-width="110" label="发起时间" prop="createTime">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.createTime, '{y}-{m}-{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="110" label="更新时间" prop="updateTime">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.updateTime, '{y}-{m}-{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="toApproveInfo(scope.row.processId, scope.row.nodeProcessStatus)"
              v-if="listType == 'myapproval'">{{
                scope.row.nodeProcessStatus ===
                'waitMe' ? '审批' : '详情'
              }}
            </el-button>
            <el-button type="text" @click="toApproveInfo(scope.row.processId, scope.row.processStatus)"
              v-if="listType == 'mylauch'">{{ scope.row.processStatus ===
                'waitMe' ? '审批' : '详情'
              }}
            </el-button>
            <el-button type="text" class="grey" @click="handleRecall(scope.row)" v-if="scope.row.processStatus === 'ing'">
              撤回</el-button>
          </template>
        </el-table-column>
      </el-table>
      <transition name="el-zoom-in-bottom">
        <span class="top-btn" v-show="topBtnShow" @click="handleListTable2Top"></span>
      </transition>

    </div>
    <div class="pager-layer">
      <el-pagination size="small" :total="total" :current-page="queryParams.pageNum"
        layout="sizes, total, prev, pager, next " :page-sizes="[5, 10, 20, 100]" :page-size="queryParams.pageSize"
        @size-change="sizeChange" @current-change="pageChange" />
    </div>

  </div>
</template>
<script>
import {
  listLaunchApi,
  listCheckApi,
  recallProcess
} from "@/api/space/approve";
// import initDataApprove from "@/mixins/initDataApprove";
import { parseTime } from "@/utils/index";
import { mapState } from "vuex";
export default {
  // mixins: [initDataApprove],
  data() {
    return {
      listType: undefined,
      flowMainTypeOptions: [{
        dictLabel: "全部",
        dictValue: "all"
      }],
      myapprovalProcessStatusOptions: [{
        dictLabel: "全部",
        dictValue: "all"
      }],
      mylauchProcessStatusOptions: [{
        dictLabel: "全部",
        dictValue: "all"
      }],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        flowMainType: "all",
        processName: undefined,
        nodeProcessStatus: "all",
        processstatus: "all",
        launchUserName: undefined
      },
      lastFlag: "",
      total: 0,
      tableList: [],
      loading: false,
      topBtnShow: false
    };
  },
  computed: mapState(["companyList", "currentSpace", "userInfo"]),
  created() {
    // this.getContractListHandle()
    this.listType = this.$route.query.status;
    this.$nextTick(() => {
      this.getDicts('cus_flow_type').then(response => {
        this.flowMainTypeOptions.push(...response.data);
      })
      this.getDicts('cus_seal_type').then(response => {
        this.sealTypeOptions = response.data
      })
      this.getDicts('cus_node_process_status').then(response => {
        this.myapprovalProcessStatusOptions.push(...response.data);
      })
      this.getDicts('cus_process_status').then(response => {
        this.mylauchProcessStatusOptions.push(...response.data);
      })
      // this.init();
    });
  },
  mounted() {
    window
      .addEventListener("scroll", (e) => {
        if (this.$refs.listTableRef) {
          let target = this.$refs.listTableRef.$el.querySelector(".el-table__body-wrapper");
          e.preventDefault();
          // e.stopPropagation();
          if (target.scrollTop > 100) {
            this.topBtnShow = true;
          } else {
            this.topBtnShow = false;
          }
        }
      }, true)
    window.addEventListener("resize", this.resiezeListTableRefEventHandler, true)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resiezeListTableRefEventHandler, true)
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        // if (!this.isGetRoute) {
        //   this.initList();
        //   this.isGetRoute = !this.isGetRoute;
        // }
        this.listType = this.$route.query.status;
        this.initList();
      }
    }
  },


  methods: {
    resiezeListTableRefEventHandler() {
      if (this.$refs.listTableRef) {
        this.$refs.listTableRef.doLayout();
        document.querySelector(".el-table .el-table__fixed-right").style.maxHeight = 46 * (this.tableList.length + 1) + 'px';
        document.querySelector(".el-table .el-table__fixed-right").style['box-shadow'] = '-2px 0px 2px 0px rgba(0,0,0,0.1)';
        document.querySelector(".table-layer").style.height = document.getElementById("approve-block").offsetHeight - document.querySelector(".filter-layer").offsetHeight - 32 - 20 - 60 + "px";
      }
    },
    calcQueryParamsDisable() {
      let { processName, launchUserName, flowMainType, processStatus, nodeProcessStatus } = this.queryParams;
      if (!processName && !launchUserName
        &&
        (flowMainType == "all" || flowMainType == "")
        &&
        (processStatus == "all" || processStatus == "")
        &&
        (nodeProcessStatus == "all" || nodeProcessStatus == "")
      ) {
        return true;
      } else {
        return false
      }
    },
    initList() {
      let apiHandler = this.$route.query.status == "mylauch" ? listLaunchApi : listCheckApi;
      this.queryParams = {
        flowMainType: this.$route.query.flowMainType || "all",
        processName: this.$route.query.processName || "",
        processStatus: (this.$route.query.status == "mylauch" && this.$route.query.processStatus) ? this.$route.query.processStatus : "all",
        nodeProcessStatus: (this.$route.query.status == "myapproval" && this.$route.query.nodeProcessStatus) ? this.$route.query.nodeProcessStatus : "all",
        launchUserName: this.$route.query.launchUserName ? this.$route.query.launchUserName : "",
        pageNum: this.$route.query.pageNum ? Number(this.$route.query.pageNum) : 1,
        pageSize: this.$route.query.pageSize ? Number(this.$route.query.pageSize) : 10,
        status: this.$route.query.status,

        // pageNum: this.$route.query.pageNum ? Number(this.$route.query.pageNum) : 1,
        // pageSize: this.$route.query.pageSize ? Number(this.$route.query.pageSize) : 5,
        // taskName: this.$route.query.taskName ? this.$route.query.taskName : undefined,
        // dateRange: this.$route.query.startSignTime ? [this.$route.query.startSignTime, this.$route.query.endSignTime] : undefined,
        // startSignTime: this.$route.query.startSignTime ? this.$route.query.startSignTime : undefined,
        // endSignTime: this.$route.query.endSignTime ? this.$route.query.endSignTime : undefined,
        // initiatorName: this.$route.query.initiatorName ? this.$route.query.initiatorName : undefined,
        // signerName: this.$route.query.signerName ? this.$route.query.signerName : undefined,
        // taskType: this.$route.query.taskType ? this.$route.query.taskType : undefined,
        // companyId: this.currentSpace.companyId || "",
        // status: this.$route.query.status,
      }
      let queryParams = Object.assign({}, this.queryParams);
      queryParams.flowMainType == "all" && (queryParams.flowMainType = "");
      queryParams.processStatus == "all" && (queryParams.processStatus = "");
      queryParams.nodeProcessStatus == "all" && (queryParams.nodeProcessStatus = "");
      this.loading = true
      apiHandler(queryParams).then(res => {
        if (res.code != 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'warning'
          });
        } else {
          this.loading = false;
          this.total = res.data.total;
          this.tableList = res.data.rowArray;

          document.querySelector(".el-table .el-table__fixed-right").style.maxHeight = 46 * (this.tableList.length + 1) + 'px';
          document.querySelector(".el-table .el-table__fixed-right").style['box-shadow'] = '-2px 0px 2px 0px rgba(0,0,0,0.1)';
          document.querySelector(".table-layer").style.height = document.getElementById("approve-block").offsetHeight - document.querySelector(".filter-layer").offsetHeight - 32 - 20 - 60 + "px";

        }
      }).catch(err => {
        this.loading = false;
      })
    },

    handleListTable2Top() {
      this.$refs.listTableRef.$el.querySelector(".el-table__body-wrapper").scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },

    handleResetForm() {
      this.$refs["queryForm"].resetFields();
      this.queryParams = Object.assign({}, this.queryParams, {
        pageNum: 1,
        pageSize: 10,
        flowMainType: "all",
        processName: "",
        processStatus: "all",
        nodeProcessStatus: "all",
        launchUserName: ""
      })

      this.handleQuery();
    },

    // 审批类型字典翻译
    flowMainTypeFormat(row, column) {
      return this.selectDictLabel(this.flowMainTypeOptions, row.flowType)
    },

    // 流程状态字典翻译
    myapprovalProcessStatusFormat(row, column) {
      let formatStatusProp = {};
      formatStatusProp.statusText = this.selectDictLabel(this.myapprovalProcessStatusOptions, row.nodeProcessStatus);
      switch (row.nodeProcessStatus) {
        case 'waitMe': formatStatusProp.bg = "#448DF7";
          break;
        case 'waitOther': formatStatusProp.bg = "#8A34FA";
          break;
        case 'pass': formatStatusProp.bg = "#00B42A";
          break;
        case 'reject': formatStatusProp.bg = "#EC5B56";
          break;
        case 'recall': formatStatusProp.bg = "#CCCCCC";
          break;
        case 'end': formatStatusProp.bg = "#CCCCCC";
          break;
        default: return;
      }
      return formatStatusProp;
    },

    // 流程状态字典翻译
    mylauchProcessStatusFormat(row, column) {
      let formatStatusProp = {};
      formatStatusProp.statusText = this.selectDictLabel(
        this.mylauchProcessStatusOptions,
        row.processStatus
      );
      switch (row.processStatus) {
        case 'ing': formatStatusProp.bg = "#EFB040";
          break;
        case 'pass': formatStatusProp.bg = "#00B42A";
          break;
        case 'reject': formatStatusProp.bg = "#EC5B56";
          break;
        case 'recall': formatStatusProp.bg = "#CCCCCC";
          break;
        case 'end': formatStatusProp.bg = "#CCCCCC";
          break;
        default: return;
      }
      return formatStatusProp;
    },

    // beforeInit() {
    //   // console.log(this.queryParams.dateRange);
    //   this.url = this.$route.query.status == "mylauch" ? listLaunchApi : listCheckApi;
    //   if (this.lastFlag != this.$route.query.status) {
    //     this.page = 1;
    //   }
    //   this.lastFlag = this.$route.query.status;
    //   this.params = {
    //     flowMainType: this.queryParams.flowMainType,
    //     processName: this.queryParams.processName,
    //     processStatus: this.$route.query.status == "mylauch" ? this.queryParams.processStatus : undefined,
    //     nodeProcessStatus: this.$route.query.status == "myapproval" ? this.queryParams.nodeProcessStatus : undefined,
    //     launchUserName: this.queryParams.launchUserName,
    //     pageNum: this.page > 0 ? this.page : 1,
    //     pageSize: this.size,
    //   };
    //   return true;
    // },

    pageChange(e) {
      this.queryParams.pageNum = e
      this.handleQuery()
    },
    sizeChange(e) {
      // this.page = 0
      this.queryParams.pageSize = e
      this.handleQuery()
    },


    handleQuery() {
      let queryParams = {};
      // 路由参数去重 否则路由监听会触发两次
      Object.keys(this.queryParams).forEach(key => {
        if (this.queryParams[key]) {
          queryParams[key] = this.queryParams[key];
        }
      })
      this.$router.push({
        url: "/approve/list",
        query: queryParams
      })
    },

    toApproveInfo(processId, processStatus) {
      this.$router.push({
        path: "/approve-info",
        query: {
          processId,
          processStatus,
          from: this.$route.query.status
        },
      });
    },
    handleRecall(row) {
      this.$confirm(
        '是否确认撤回流程 "' + row.processName + '" 的业务审批?',
        '警告',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true,
          showClose: false
        }
      )
        .then(() => {
          recallProcess({
            processId: row.processId
          }).then(response => {
            if (response.code === 200) {
              this.msgSuccess('撤回成功')
              this.initList();
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: 'warning'
              })
            }
          })
        })
        .catch(function () { })
    },
  },
};
</script>

<!-- <style lang="scss" scoped>
#approve-block {
  position: relative;
}

.el-submenu.is-active .el-submenu__title {
  border-left: 3px solid #3296fa;
}

.scope-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filter-layer {
  margin-top: 30px;
  // height: 100px;
  padding-left: 30px;
  // margin-bottom: 20px;
}
</style> -->


<style lang="scss" scoped>
.content-block {
  padding: 32px 0 0 20px;
  position: relative;
  height: 100%;
}

.filter-layer {
  .el-button /deep/ span {
    display: flex;
    align-items: center;

    .svg-icon {
      margin-right: 7px;
    }
  }
}

.pager-layer {
  width: 100%;
  height: 60px;
  padding-right: 20px;
  position: absolute;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: #fff;
  z-index: 99;
}

.el-form-item {
  // margin-right: 24px;
  // margin-bottom: 16px;
  // height: 32px;
  // line-height: 32px;

  // /deep/ .el-form-item__label {
  //   font-size: 14px;
  //   font-weight: 400;
  //   color: #4E5969;
  // }

  // &+.el-form-item {
  //     // margin-left: 24px;


  // }

  .el-button {
    min-width: 84px;
  }
}

.el-input {
  height: 32px;
  line-height: 32px;

  /deep/ .el-input__inner {
    width: 240px;
  }
}

.el-select {
  /deep/ .el-input__inner {
    // width: 240px;
    width: 240px;
  }
}


.stand-btn {
  margin-top: 8px;
}

.table-layer {
  margin-top: 20px;
  height: auto;
  padding-right: 20px;

  .top-btn {
    display: block;
    width: 60px;
    height: 60px;
    background: url(../../assets/icons/png/icon-top.png) center no-repeat;
    background-size: 100%;
    // box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.1);
    // border: 1px solid rgba(220, 220, 220, 0.5);
    position: absolute;
    right: 40px;
    bottom: 68px;
    z-index: 999;
    color: #93A4BC;
    padding: 0;
    cursor: pointer;
  }

  .dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 3px;
    margin-right: 8px;
  }

  /deep/ .selection-column .cell {
    padding-left: 12px !important;
  }

}

.el-table {
  width: 100%;

  /deep/ .el-table__row td:nth-last-of-type(1) .cell,
  /deep/ thead th:nth-last-of-type(1) .cell {
    padding-left: 14px !important;
  }

  // /deep/ .cell {
  //   padding-left: 14px !important;
  //   padding-right: 10px !important;
  //   // padding: 0 !important;
  // }

  /deep/ .el-table__cell {
    height: 46px;
    padding: 0 !important;
  }

  /deep/ .el-table__fixed,
  /deep/ .el-table__fixed-right {
    // box-shadow: -2px 0px 2px 0px rgba(0, 0, 0, 0.1);
    box-shadow: none;
    height: 0;
  }

  /deep/ .el-table__body-wrapper.is-scrolling-right~.el-table__fixed-right {
    box-shadow: none;
  }

  .el-button--text {
    font-size: 14px;
    font-weight: 400;
    color: #165DFF;
    padding: 0;

    &.grey {
      color: #86909C;
    }

    &:hover {
      opacity: .7;
    }

    &.danger {
      color: #EC5B56;
    }

  }

  .el-button+.el-button {
    margin-left: 11px;
  }
}
</style>
